
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexUf1ctEhWGK1BdAjVn_wWZvmsQ6r_45HDl6tnia51nEfOwMeta } from "/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/index.vue?macro=true";
import { default as contactsBIvZTnRfFd7HKWeo5u6oIzYM9igmJ1npE2ni6mgWAgIMeta } from "/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/contacts.vue?macro=true";
import { default as legal_45warningehVKqu7oKCdr7axvzcMGilabGuxoma5YW242ve_CFB0Meta } from "/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/legal-warning.vue?macro=true";
import { default as privacy_45policyTWpahi0B2_45Vv1C5ncQhGqzDuyqzk1zRjeo4V4r8JiIAMeta } from "/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/privacy-policy.vue?macro=true";
import { default as report_iHhAiGx_45qVv2lDCKJTCb_45S8SXjA6T7Qt4ybE0P9Gc4Meta } from "/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/product/report.vue?macro=true";
import { default as billingvBVpxJk3GhxRK1JeH_xqW_Tc4MH_45EfxHS4ZiV1xJkmgMeta } from "/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/product/billing.vue?macro=true";
import { default as groups_45aoPt6bXzTyAcYddxpSpHVyjb4l_45IJVkRDHZaC8BPNcMeta } from "/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/services/groups.vue?macro=true";
import { default as bookingsAkz1fVtV6Mf4L4Q9vUe4typRWqCJfo_37T_45_yhJMLM8Meta } from "/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/product/bookings.vue?macro=true";
import { default as meetingsoyhl0LfpmRQ5N7QFls53jq0phpM3_45yT97Wms6WKENGMMeta } from "/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/services/meetings.vue?macro=true";
import { default as corporateSw_45jGmhnYs7cW5ZnDqfpZ18LPwnp_458q8huzNl9SpIjkMeta } from "/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/services/corporate.vue?macro=true";
import { default as integrationsOfBGvp58wagp25Bbjn5B5iPj7GVq_45SW_45TQyOoC_45cqC8Meta } from "/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/product/integrations.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexUf1ctEhWGK1BdAjVn_wWZvmsQ6r_45HDl6tnia51nEfOwMeta || {},
    component: () => import("/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/index.vue")
  },
  {
    name: "contacts",
    path: "/contactos",
    meta: contactsBIvZTnRfFd7HKWeo5u6oIzYM9igmJ1npE2ni6mgWAgIMeta || {},
    component: () => import("/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/contacts.vue")
  },
  {
    name: "legal-warning",
    path: "/aviso-legal",
    meta: legal_45warningehVKqu7oKCdr7axvzcMGilabGuxoma5YW242ve_CFB0Meta || {},
    component: () => import("/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/legal-warning.vue")
  },
  {
    name: "privacy-policy",
    path: "/politica-de-privacidad",
    meta: privacy_45policyTWpahi0B2_45Vv1C5ncQhGqzDuyqzk1zRjeo4V4r8JiIAMeta || {},
    component: () => import("/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/privacy-policy.vue")
  },
  {
    name: "product-report",
    path: "/productos/report",
    meta: report_iHhAiGx_45qVv2lDCKJTCb_45S8SXjA6T7Qt4ybE0P9Gc4Meta || {},
    component: () => import("/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/product/report.vue")
  },
  {
    name: "product-billing",
    path: "/productos/facturacion-electronica",
    meta: billingvBVpxJk3GhxRK1JeH_xqW_Tc4MH_45EfxHS4ZiV1xJkmgMeta || {},
    component: () => import("/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/product/billing.vue")
  },
  {
    name: "services-groups",
    path: "/servicios/grupos-e-incentivos",
    meta: groups_45aoPt6bXzTyAcYddxpSpHVyjb4l_45IJVkRDHZaC8BPNcMeta || {},
    component: () => import("/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/services/groups.vue")
  },
  {
    name: "product-bookings",
    path: "/productos/reservas-online",
    meta: bookingsAkz1fVtV6Mf4L4Q9vUe4typRWqCJfo_37T_45_yhJMLM8Meta || {},
    component: () => import("/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/product/bookings.vue")
  },
  {
    name: "services-meetings",
    path: "/servicios/reuniones-y-eventos",
    meta: meetingsoyhl0LfpmRQ5N7QFls53jq0phpM3_45yT97Wms6WKENGMMeta || {},
    component: () => import("/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/services/meetings.vue")
  },
  {
    name: "services-corporate",
    path: "/servicios/viajes-corporativos",
    meta: corporateSw_45jGmhnYs7cW5ZnDqfpZ18LPwnp_458q8huzNl9SpIjkMeta || {},
    component: () => import("/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/services/corporate.vue")
  },
  {
    name: "product-integrations",
    path: "/productos/integracion-de-sistemas",
    meta: integrationsOfBGvp58wagp25Bbjn5B5iPj7GVq_45SW_45TQyOoC_45cqC8Meta || {},
    component: () => import("/var/www/RasoDEV/Web/Geotur.es/Source/geotur.es/pages/product/integrations.vue")
  }
]